export default "__VITE_ASSET__44661bc0__"